<template>
  <div>
      <Head :title="__('Dashboard')" />

      <!-- ── KPI Cards ──────────────────────────────────────────── -->
      <div class="kpi__row">

          <!-- Novos Tickets — azul (neutro) -->
          <div class="kpi__card kpi--blue cursor-pointer" @click="goToLink(this.route('tickets', {'type': 'new'}))">
              <div class="kpi__accent"></div>
              <div class="kpi__body">
                  <span class="kpi__label">{{ __('Novos Tickets') }}</span>
                  <span class="kpi__number">{{ new_tickets }}</span>
                  <span class="kpi__trend">
                      <span class="kpi__trend-icon">📋</span>
                      {{ __('Em Andamento') }}
                  </span>
              </div>
              <div class="kpi__icon kpi__icon--blue">
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/></svg>
              </div>
          </div>

          <!-- Tickets Abertos — cinza azulado (em andamento) -->
          <div class="kpi__card kpi--slate cursor-pointer" @click="goToLink(this.route('tickets', {'type': 'open'}))">
              <div class="kpi__accent"></div>
              <div class="kpi__body">
                  <span class="kpi__label">{{ __('Tickets Abertos') }}</span>
                  <span class="kpi__number">{{ opened_tickets }}</span>
                  <span class="kpi__trend">
                      <span class="kpi__trend-icon">🔓</span>
                      {{ __('Aberto') }}
                  </span>
              </div>
              <div class="kpi__icon kpi__icon--slate">
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
              </div>
          </div>

          <!-- Tickets Fechados — verde (sucesso) -->
          <div class="kpi__card kpi--green cursor-pointer" @click="goToLink(this.route('tickets', {'search': 'close'}))">
              <div class="kpi__accent"></div>
              <div class="kpi__body">
                  <span class="kpi__label">{{ __('Tickets Fechados') }}</span>
                  <span class="kpi__number">{{ closed_tickets }}</span>
                  <span class="kpi__trend">
                      <span class="kpi__trend-icon">✅</span>
                      {{ __('Resolvido') }}
                  </span>
              </div>
              <div class="kpi__icon kpi__icon--green">
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 11-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" /></svg>
              </div>
          </div>

          <!-- Não Atribuídos — vermelho/laranja (alerta) -->
          <div v-if="auth.user.role.slug !== 'customer'" class="kpi__card kpi--red cursor-pointer" @click="goToLink(this.route('tickets', {'type': 'un_assigned'}))">
              <div class="kpi__accent"></div>
              <div class="kpi__body">
                  <span class="kpi__label">{{ __('Tickets Não Atribuídos') }}</span>
                  <span class="kpi__number">{{ un_assigned_tickets }}</span>
                  <span class="kpi__trend kpi__trend--alert" v-if="un_assigned_tickets > 0">
                      <span class="kpi__trend-icon">⚠️</span>
                      {{ __('Pendente') }}
                  </span>
                  <span class="kpi__trend" v-else>
                      <span class="kpi__trend-icon">✅</span>
                      OK
                  </span>
              </div>
              <div class="kpi__icon kpi__icon--red">
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" /></svg>
              </div>
          </div>

      </div>

      <!-- ── Linha do Meio: Departamentos + Criadores + Tipos ─── -->
      <div class="mid__row" v-if="auth.user.role.slug !== 'customer'">

          <!-- Gráfico de Barras Horizontais — por Organização -->
          <div class="mid__card mid__card--wide">
              <h2 class="card__title">{{ __('Tickets por organização') }}</h2>
              <div class="hbar__list">
                  <template v-if="top_organizations.length">
                      <div class="hbar__item" v-for="(org, i) in top_organizations" :key="'midorg'+i">
                          <span class="hbar__label" :title="org.label">{{ org.label }}</span>
                          <div class="hbar__track">
                              <div class="hbar__fill" :style="{ width: org.value + '%', background: org.color }"></div>
                          </div>
                          <span class="hbar__count">{{ org.count }}</span>
                          <span class="hbar__pct">{{ org.value }}%</span>
                      </div>
                  </template>
                  <div v-else class="hbar__empty">{{ __('Nenhum dado encontrado.') }}</div>
              </div>
          </div>

          <!-- Top 5 Criadores — lista com barra de progresso -->
          <div class="mid__card mid__card--wide">
              <h2 class="card__title">{{ __('Maiores criadores de tickets') }}</h2>
              <div class="creator__list">
                  <template v-if="top_creators.length">
                      <div class="creator__item" v-for="(c, i) in top_creators" :key="i">
                          <span class="creator__rank">{{ i + 1 }}</span>
                          <div class="creator__info">
                              <div class="creator__name-row">
                                  <span class="creator__name">{{ c.label }}</span>
                                  <span class="creator__count">{{ c.count }}</span>
                              </div>
                              <div class="creator__bar-track">
                                  <div class="creator__bar-fill" :style="{ width: c.value + '%', background: c.color }"></div>
                              </div>
                          </div>
                          <span class="creator__pct">{{ c.value }}%</span>
                      </div>
                  </template>
                  <div v-else class="hbar__empty">{{ __('Nenhum dado encontrado.') }}</div>
              </div>
          </div>

          <!-- Ticket por Produto -->
          <div class="mid__card">
              <h2 class="card__title">{{ __('Tickets por produto') }}</h2>
              <div class="type__list">
                  <template v-if="top_products.length">
                      <div class="type__item" v-for="(t, i) in top_products" :key="i">
                          <span class="type__dot" :style="{ background: t.color }"></span>
                          <span class="type__label">{{ t.label }}</span>
                          <span class="type__count">{{ t.count }}</span>
                          <span class="type__pct">{{ t.value }}%</span>
                      </div>
                  </template>
                  <div v-else class="hbar__empty">{{ __('Nenhum dado encontrado.') }}</div>
              </div>
          </div>

      </div>

      <!-- ── Base: Histórico + SLA + Clientes/Contatos ────────── -->
      <div class="bot__row" v-if="auth.user.role.slug !== 'customer'">

          <!-- Histórico de Tickets -->
          <div class="bot__card bot__card--history">
              <h2 class="card__title">{{ __('Histórico de tickets') }}</h2>
              <div class="hist__summary">
                  <span class="hist__num">{{ chart_line.this_month }}</span>
                  <span class="hist__sub">/ {{ __('este mês') }}</span>
                  <span class="hist__prev">{{ __('mês anterior') }}: <strong>{{ chart_line.last_month }}</strong></span>
              </div>
              <div v-if="months.length" class="hist__bars">
                  <div class="hist__col" v-for="cl in months" :key="cl.month">
                      <div class="hist__bar-wrap">
                          <div class="hist__bar-fill" :style="{ height: cl.value }"></div>
                      </div>
                      <span class="hist__label">{{ cl.month }}</span>
                  </div>
              </div>
          </div>

          <!-- Contadores: Clientes, Organizações, Contatos -->
          <div class="bot__card bot__card--counters">
              <h2 class="card__title">{{ __('Visão Geral') }}</h2>
              <div style="display: flex; gap: 1.5rem; flex-wrap: wrap; padding: 0.5rem 0;">
                  <div class="counter__item">
                      <svg class="counter__icon" viewBox="0 0 24 24" fill="none" stroke="#2563eb" stroke-width="2"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>
                      <span class="counter__label">{{ __('Clientes') }}</span>
                      <span class="counter__num">{{ total_customer }}</span>
                  </div>
                  <div class="counter__item">
                      <svg class="counter__icon" viewBox="0 0 24 24" fill="none" stroke="#16a34a" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"/><path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"/></svg>
                      <span class="counter__label">{{ __('Organizações') }}</span>
                      <span class="counter__num">{{ total_organizations }}</span>
                  </div>
                  <div class="counter__item">
                      <svg class="counter__icon" viewBox="0 0 24 24" fill="none" stroke="#ea580c" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                      <span class="counter__label">{{ __('Contatos') }}</span>
                      <span class="counter__num">{{ total_contacts }}</span>
                  </div>
              </div>
          </div>

      </div>

      <!-- Carregando -->
      <div v-if="loading" class="processing-overlay">
          <div class="background"></div>
          <div class="loader">
              <svg width="200px" height="200px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" style="background: none;">
                  <circle cx="75" cy="50" fill="#ffffff" r="6.39718">
                      <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.875s"></animate>
                  </circle>
                  <circle cx="67.678" cy="67.678" fill="#ffffff" r="4.8">
                      <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.75s"></animate>
                  </circle>
                  <circle cx="50" cy="75" fill="#ffffff" r="4.8">
                      <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.625s"></animate>
                  </circle>
                  <circle cx="32.322" cy="67.678" fill="#ffffff" r="4.8">
                      <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.5s"></animate>
                  </circle>
                  <circle cx="25" cy="50" fill="#ffffff" r="4.8">
                      <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.375s"></animate>
                  </circle>
                  <circle cx="32.322" cy="32.322" fill="#ffffff" r="4.80282">
                      <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.25s"></animate>
                  </circle>
                  <circle cx="50" cy="25" fill="#ffffff" r="6.40282">
                      <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.125s"></animate>
                  </circle>
                  <circle cx="67.678" cy="32.322" fill="#ffffff" r="7.99718">
                      <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="0s"></animate>
                  </circle>
              </svg>
          </div>
      </div>

  </div>
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import Icon from '@/Shared/Icon'

export default {
  metaInfo: { title: 'Dashboard' },
    components: {
        Head,
        Icon,
        Link,
    },
  layout: Layout,
    props: {
        auth: Object,
        entries: Array,
        chart_line: Object,
        api_key: String,
        new_tickets: Number,
        total_tickets: Number,
        un_assigned_tickets: Number,
        opened_tickets: Number,
        closed_tickets: Number,
        first_response: Array,
        top_creators: Array,
        last_response: Array,
        top_departments: Array,
        top_types: Array,
        top_products: Array,
        top_organizations: Array,
        total_customer: Number,
        total_organizations: Number,
        total_contacts: Number,
    },
    data() {
        return {
            errors: [],
            loading: false,
            firstResponse: [],
            lastResponse: [],
            months: []
        }
    },
    created() {
        for (let i = 0; i < this.first_response.length; i++) {
            if(i % 2 === 0){
                this.firstResponse = [...this.firstResponse, [this.first_response[i], this.first_response[i+1]]]
            }
        }
        for (let i = 0; i < this.last_response.length; i++) {
            if(i % 2 === 0){
                this.lastResponse = [...this.lastResponse, [this.last_response[i], this.last_response[i+1]]]
            }
        }

        this.months = this.chart_line.previousMonths.map( m =>{
            return { 'month': m, 'value': this.chart_line.months[m] ? ((this.chart_line.months[m] * 100)/this.chart_line.total)+'%': '0%' }
        })
    },
    methods: {
        goToLink(link){
            window.location.href = link;
        },
    },
}
</script>